import { ReactComponent as GoogleMark } from "../assets/auth/google-g.svg";
import { ReactComponent as TelegramMark } from "../assets/auth/telegram-plane.svg";
import downloadBanner from "../assets/auth/downloadBanner";
import UnavailableFeatureDialog from "./UnavailableFeatureDialog";
import React, { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import OutsideClickHandler from "react-outside-click-handler";
import { t } from "i18next";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import PasswordRecoveryDialog from "./PasswordRecoveryDialog";

const Login = ({ setLoginModal }) => {
  const [unavailableFeature, setUnavailableFeature] = useState(null);
  const [recoveryOpen, setRecoveryOpen] = useState(false);
  const loginUser = useContextSelector(AuthContext, (ctx) => ctx.loginUser);
  const loginModal = useContextSelector(AuthContext, (ctx) => ctx.loginModal);
  const setRegisterModal = useContextSelector(AuthContext, (ctx) => ctx.setRegisterModal);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    loginUser(data);
  };

  useEffect(() => {
    const bodyClass = "on-show";
    if (loginModal) {
      document.body.classList.add(bodyClass);
    } else {
      document.body.classList.remove(bodyClass);
    }
    return () => document.body.classList.remove(bodyClass);
  }, [loginModal]);

  if (!loginModal) return null;

  return (
    <div className="v--modal-overlay" aria-expanded="true" data-modal="loginPopupModal">
      {recoveryOpen && <PasswordRecoveryDialog onClose={() => setRecoveryOpen(false)} />}
      {unavailableFeature && <UnavailableFeatureDialog feature={unavailableFeature} onClose={() => setUnavailableFeature(null)} />}
      <div className="v--modal-background-click">
        <div className="v--modal-top-right" />
        <div
          role="dialog"
          aria-modal="true"
          className="v--modal-box v--modal"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100dvh",
          }}
        >
          <OutsideClickHandler onOutsideClick={() => { if (!unavailableFeature && !recoveryOpen) setLoginModal(false); }}>
            <div style={{ width: "fit-content" }} className="tcg_modal_wrap hasBg">
              <div className="tcg_modal_body">
                <div className="loginmodal-bg">
                  <button
                    type="button"
                    aria-label="Close"
                    onClick={() => setLoginModal(false)}
                    className="tcg_modal_close special ref-auth-close"
                  >
                    <span className="tcg_modal_close_text" />
                  </button>
                  <div className="login_wrap">
                    <div className="login-title">
                      <img className="ref-auth-logo" src="/assets/chorki/logo.svg" alt="chorki" />
                      <div className="login-title__text">{t("Login")}</div>
                    </div>
                    <div className="login-form">
                      <Form onSubmit={handleSubmit(onSubmit)} data-vv-scope="login-form">
                        <div className="form_item">
                          <div className="label-box">
                            <p className="label-text">{t("Username")}</p>
                            <p className="errorMsg" />
                          </div>
                          <div className="item_box user">
                            <input
                              placeholder={t("Username")}
                              {...register("username", {
                                required: t("Enter_Username"),
                                minLength: { value: 6, message: t("Min3User") },
                                maxLength: { value: 13, message: t("Max30User") },
                                pattern: {
                                  value: /^[A-Za-z0-9]{6,13}$/,
                                  message: t("Enter_Valid_Username"),
                                },
                              })}
                              type="text"
                              name="username"
                              className="username_input"
                              aria-required="true"
                              aria-invalid={
                                !isEmpty(errors.username) && !isEmpty(errors.username.message)
                                  ? true
                                  : "false"
                              }
                            />
                          </div>
                          {errors.username && <p className="ref-auth-hint" role="alert">
                            {errors.username.type === "required" ? t("Enter_Username") : "Please enter 6 - 13 characters using only letters or numbers. No special characters allowed."}
                          </p>}
                        </div>
                        <div className="form_item password">
                          <div className="label-box">
                            <p className="label-text">{t("Password")}</p>
                            <p className="errorMsg" />
                          </div>
                          <div className="item_box pass">
                            <input
                              type="password"
                              name="password"
                              className="password_input"
                              placeholder={t("Password")}
                              {...register("password", {
                                required: t("Enter_Password"),
                                minLength: { value: 6, message: t("PasswordMin") },
                                maxLength: { value: 20, message: t("PasswordMax") },
                              })}
                              aria-required="true"
                              aria-invalid={
                                !isEmpty(errors.password) && !isEmpty(errors.password.message)
                                  ? true
                                  : "false"
                              }
                            />
                            <button
                              type="button"
                              className="ref-auth-forgot"
                              onClick={() => setRecoveryOpen(true)}
                            >
                              Forgot Password?
                            </button>
                          </div>
                          {errors.password && <p className="ref-auth-hint" role="alert">
                            {errors.password.type === "required" ? t("Enter_Password") : "Please enter 6 - 20 characters."}
                          </p>}
                        </div>
                        <div className="form_item rem-wrap">
                          <div className="form_item remember-item">
                            <div className="remPass_box">
                              <input type="checkbox" className="remPass_checkbox" />
                              <span className="cheched-bg" />
                              <span className="gougou" />
                            </div>
                            <span className="jzmm">{t("Remember")}</span>
                          </div>
                          <span className="forget">{t("ForgotPassword")}</span>
                        </div>
                        <div className="form_item btn-wrap">
                          <button type="submit" className="submit_btn">
                            {t("Login")}
                          </button>
                        </div>
                      </Form>
                    </div>
                    <div className="tip1">
                      <span>{t("Noaccountyet")}</span>
                      <button
                        type="button"
                        className="register-tip"
                        onClick={() => {
                          setLoginModal(false);
                          setRegisterModal(true);
                        }}
                      >
                        {t("Register")}
                      </button>
                    </div>
                    <div className="ref-auth-social">
                      <div className="ref-auth-social-tip">
                        <span>or connect with</span>
                      </div>
                      <div className="ref-auth-social-row">
                        <button
                          type="button"
                          className="ref-auth-social-btn google square"
                          aria-label="Google"
                          onClick={() => setUnavailableFeature("Google sign-in")}
                        >
                          <GoogleMark aria-hidden="true" />
                        </button>
                        <button
                          type="button"
                          className="ref-auth-social-btn telegram square"
                          aria-label="Telegram"
                          onClick={() => setUnavailableFeature("Telegram sign-in")}
                        >
                          <TelegramMark aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                    <a
                      className="ref-auth-oneone login"
                      href="https://1.1.1.1/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={downloadBanner} alt="Download 1.1.1.1" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </OutsideClickHandler>
        </div>
      </div>
    </div>
  );
};

export default Login;
